export const spaceUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
